import produce from "immer";
import { createSelector } from "reselect";
import { User } from "../../types/orders/user";
import {
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT
  } from "../constants";
  

  const userStorage: any = localStorage.getItem("user");
  const user: User | null = userStorage? JSON.parse(userStorage) as User: null;
  
  const initialState = { isLoggedIn: !!user, user };
  
  export default (state = initialState, action: any) => { 
    return produce(state, (draft) =>  {
        switch (action.type) {
            case LOGIN_SUCCESS:
                draft.isLoggedIn= true;
                draft.user= action.payload.user;
                return draft;
            case LOGIN_FAILURE:
                draft.isLoggedIn= false;
                draft.user= null;
                return draft;
            case LOGOUT:
                draft.isLoggedIn= false;
                draft.user= null;
                return draft;
            default:
                return state;
        }
    });
  }

const getAuthState = (state: any) => state.auth;
createSelector(
    getAuthState,
    (authState) => authState.user.type
);
createSelector(
    getAuthState,
    (authState) => authState.user.token
);
